<script>
	import LandingPage_Closed from './LandingPage_Closed.svelte';

	import { pageNumber, model } from '../../stores';

	export let pageIndex = null;
	export let pageTitle = null;
	export let lastVisitedPage = null;

	$pageNumber = pageIndex;
	$model.LastPageVisited = lastVisitedPage;
	document.title = pageTitle;

	//  Get the user Agent
	$model.UserAgent = navigator.userAgent;
	$model.referrer = document.referrer;
</script>

<LandingPage_Closed />
